<div class="scheduler-item"
  [ngClass]="{
    'scheduler-item--on-my-way': scheduledJob.status === EScheduledJobStatus.OnMyWay,
    'scheduler-item--started': scheduledJob.status === EScheduledJobStatus.Started,
    'scheduler-item--finished': scheduledJob.status === EScheduledJobStatus.Finished }"
  (click)="onClick()">
  <div class="scheduler-item-data">
    <p class="scheduler-item-data__title">
      <strong>{{ scheduledJob.title }}, </strong>
      <span [title]="scheduledJob.primaryContact">{{ scheduledJob.primaryContact }}</span>
    </p>
    <p class="scheduler-item-data__scheduled-time">
      {{ scheduledJob.startTime }} - {{ scheduledJob.endTime }}
      <span class="scheduler-item-data__short-date">{{ scheduledJob.shortDate }}</span>
    </p>
    <p *ngIf="scheduledJob.address"
      class="scheduler-item-data__address"
      [attr.title]="croppedAddress ? scheduledJob.address : null">
      {{ croppedAddress ? croppedAddress : scheduledJob.address }}
    </p>
  </div>
  <div class="scheduler-item-state">
    <div class="scheduler-item-eta"
      *ngIf="scheduledJob.estimation">
      <div i18n="@@S_SCHEDULED_JOBS_ETA"
        class="scheduler-item-eta__title">ETA
      </div>
      <div *ngIf="!scheduledJob.estimation.isOnTime">{{ scheduledJob.estimation.estimatedTime }}</div>
      <div *ngIf="scheduledJob.estimation.isOnTime"
        i18n="@@S_SCHEDULED_JOBS_STATUS_ON_TIME">On Time
      </div>
    </div>
    <div class="scheduler-item-status"
      [ngClass]="{
        'scheduler-item-status__button':
          scheduledJob.status === EScheduledJobStatus.OnMyWay ||
          scheduledJob.status === EScheduledJobStatus.Started ||
          scheduledJob.status === EScheduledJobStatus.Finished
      }">
      <div *ngIf="scheduledJob.status === EScheduledJobStatus.Sent"
        class="scheduler-item-status__label">
        <p i18n="@@S_SCHEDULED_JOBS_STATUS_SENT"
          class="scheduler-item-status__text">Sent</p>
        <mat-icon svgIcon="ic-sent"
          class="scheduler-item-status__icon mat-icon-size-special"></mat-icon>
      </div>
      <div *ngIf="scheduledJob.status === EScheduledJobStatus.Received"
        class="scheduler-item-status__label">
        <p i18n="@@S_SCHEDULED_JOBS_STATUS_RECEIVED"
          class="scheduler-item-status__text">Received</p>
        <mat-icon svgIcon="ic-received"
          class="scheduler-item-status__icon mat-icon-size-special"></mat-icon>
      </div>
      <div *ngIf="scheduledJob.status === EScheduledJobStatus.Read"
        class="scheduler-item-status__label">
        <p i18n="@@S_SCHEDULED_JOBS_STATUS_READ"
          class="scheduler-item-status__text">Read</p>
        <mat-icon svgIcon="ic-read"
          class="scheduler-item-status__icon mat-icon-size-special"></mat-icon>
      </div>
      <div *ngIf="scheduledJob.status === EScheduledJobStatus.OnMyWay"
        class="scheduler-item-status__label">
        <p i18n="@@S_SCHEDULED_JOBS_STATUS_ON_MY_WAY"
          class="scheduler-item-status__text">On My Way</p>
      </div>
      <div *ngIf="scheduledJob.status === EScheduledJobStatus.Started"
        class="scheduler-item-status__label">
        <p i18n="@@S_SCHEDULED_JOBS_STATUS_STARTED"
          class="scheduler-item-status__text">Started</p>
      </div>
      <div *ngIf="scheduledJob.status === EScheduledJobStatus.Finished"
        class="scheduler-item-status__label">
        <p i18n="@@S_SCHEDULED_JOBS_STATUS_FINISHED"
          class="scheduler-item-status__text">Finished</p>
      </div>
    </div>
  </div>
</div>
